import React from 'react';
import { AiOutlineFullscreen, AiOutlineFullscreenExit, AiOutlineInfoCircle } from 'react-icons/ai';

const Node = ({ nodeData = {}, triggerNodeToggle, foreignObjectProps = {} }) => {
    return (
        <React.Fragment>
            {/* <circle r={20}></circle> */}
            <foreignObject {...foreignObjectProps}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        border: '1px solid black',
                        borderRadius: '2pt',
                        overflow: 'hidden',
                        backgroundColor: 'rgb(248, 248, 255)',
                    }}
                >
                    <h3
                        style={{
                            fontSize: '7pt',
                            width: '100%',
                            textAlign: 'center',
                            backgroundColor: '#eaeaf3',
                            margin: 0,
                            padding: '2pt',
                        }}
                    >
                        {nodeData.name}
                    </h3>
                    <ul
                        style={{
                            listStyleType: 'none',
                            padding: 0,
                            fontSize: '8pt',
                        }}
                    >
                        {nodeData.group && (
                            <li style={{ textAlign: 'center', fontSize: '6pt' }}>{nodeData.group.description}</li>
                        )}
                    </ul>
                    <div
                        style={{
                            width: '100%',
                            height: '10pt',
                            backgroundColor: '#e4e4f9',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <span
                            style={{
                                textAlign: 'center',
                                fontSize: '6pt',
                                border: '0.2pt solid lightgray',
                                borderRadius: '2pt',
                                backgroundColor: '#eae9e9',
                                height: '9pt',
                                width: '9pt',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: '0pt 2pt',
                            }}
                            onClick={triggerNodeToggle}
                        >
                            <AiOutlineInfoCircle />
                        </span>
                        {nodeData.children && (
                            <span
                                style={{
                                    textAlign: 'center',
                                    fontSize: '6pt',
                                    border: '0.2pt solid lightgray',
                                    borderRadius: '2pt',
                                    backgroundColor: '#eae9e9',
                                    height: '9pt',
                                    width: '9pt',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    margin: '0pt 2pt',
                                }}
                                onClick={triggerNodeToggle}
                            >
                                {nodeData.__rd3t.collapsed ? <AiOutlineFullscreen /> : <AiOutlineFullscreenExit />}
                            </span>
                        )}
                    </div>
                </div>
            </foreignObject>
        </React.Fragment>
    );
};

export default Node;
